import clsx from 'clsx'

interface NoticeProps {
  icon: React.ReactNode
  children: React.ReactNode
  className?: string
}

/**
 * Notice is a function component that displays a notice with an icon and
 * some content, which can be text or another React component.
 *
 * @param {Object} props - The component's props.
 * @param {React.ReactNode} props.icon - The icon to display in the notice.
 * @param {React.ReactNode} props.children - The content to display in the notice.
 * @param {string} [props.className] - Additional CSS classes to apply to the notice.
 *
 * @returns {JSX.Element} A div element containing the notice.
 */
function Notice(props: NoticeProps) {
  return (
    <div className={clsx('flex items-center p-4 gap-4 bg-zinc-100', props.className)}>
      <div className='shrink-0'>{props.icon}</div>
      <div className='text-m-m'>{props.children}</div>
    </div>
  )
}

export default Notice
